export function isExternalUrl(url: string): boolean {
  if (!url) return false;

  const isHttpUrl = url.startsWith('http://') || url.startsWith('https://');
  if (!isHttpUrl) return false;

  return !isS3Url(url);
}

function isS3Url(url: string): boolean {
  if (!url) return false;

  return (
    url.includes('amazonaws.com') || url.includes('.s3.') || url.includes('s3-')
  );
}
